export const MY_FAVORITES_ACTIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
}

export const MY_FAVORITES_STORAGE_KEY = 'favs_pending-action'

const featurePrefix = '[LIF][My Favorites]'

export const LOG_ERROR_MESSAGE = {
  CHECK: `${featurePrefix}[Check favorite]`,
  ADD: `${featurePrefix}[Create favorite]`,
  REMOVE: `${featurePrefix}[Remove favorite]`,
  NOTIFICATION: `${featurePrefix}[Notification toast]`,
}
